import React, {useCallback} from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import {TrashButton, EditButton} from '../../../components/shared/icons';
import useBoolean from '../../../hooks/useBoolean';
import EditCustomerGroupPopup from '../popups/EditCustomerGroupPopup';
import { useTextResources } from "../../../language";
import { useConfirm } from "../../../hooks/useConfirm";

const ActionsColumn = ({row, column: {saveCustomerGroup}}) => {
    const text = useTextResources();
    const confirm  = useConfirm();
    const {
        value: isEditPopupOpen,
        setTrue: openEditPopup,
        setFalse: closeEditPopup
    } = useBoolean(false);

    const handleRemove = useCallback(() => {
        saveCustomerGroup({
            ...row,
            IsActive: false,
        });
    }, [row, saveCustomerGroup]);

    const confirmRemove = useCallback(async () => {
        await confirm({
            header: `${text('Delete')} ${text('CustomerGroup')}`,
            confirmButton: {
                content: text('Yes'),
                positive: true,
            },
            cancelButton: {
                content: text('No'),
                negative: true,
            },
            onConfirm: handleRemove,
        });
    }, [confirm, text, handleRemove]);

    return (
        <div>
            <Button.Group icon>
                <EditButton onClick={openEditPopup} style={{ marginRight: '10px' }} />
                <TrashButton onClick={confirmRemove} />
            </Button.Group>
            <EditCustomerGroupPopup
                open={isEditPopupOpen}
                customerGroup={row}
                save={saveCustomerGroup}
                onClose={closeEditPopup}
            />
        </div>
    );
};

ActionsColumn.propTypes = {
    row: PropTypes.shape({
        Id: PropTypes.number.isRequired,
    }).isRequired,
    column: PropTypes.shape({
        saveCustomerGroup: PropTypes.func.isRequired,
    }).isRequired,
};

export default ActionsColumn;